module.exports = __webpack_public_path__ + "media/images/emblems/Stettfurt-Blazono-cca69c2b31d4066e06f4eb42a1f625e4.png";